
import {OrbitComponent} from "../base-components/orbit-component/orbit-component";
import React from "react";
import {IModalDialogHandler} from "../../services/dialog/dialog.service.interface";
import {CyClass} from "../../../common/cy-classes";
import { DialogTextBox, DialogDimmedTextBox } from "../modal-dialog/boxes/text/dialog-text.box";
import {ModalDialogActionsComponent} from "../modal-dialog/modal-dialog-actions.component";
import { LugasActiveDialogBoxLine } from "./boxes/line-box";

interface ILugasActivePopupComponentProps {
    dialogHandler: IModalDialogHandler;
}

    export class LugasActivePopupComponent extends OrbitComponent<ILugasActivePopupComponentProps> {

        private _onOkPressed = () => {
            this.props.dialogHandler && this.props.dialogHandler.close();
        };

        render() {
            return (
                <div className={CyClass('cy-modal-content')}>
                    <DialogTextBox>{this.services.translation.translate("LUGAS_ACTIVE_TEXT_1")}</DialogTextBox>
                    <LugasActiveDialogBoxLine/>
                    <DialogDimmedTextBox>{this.services.translation.translate("LUGAS_ACTIVE_TEXT_2")}</DialogDimmedTextBox>
                    <ModalDialogActionsComponent
                        primaryAction={{
                            text: this.services.translation.translate("LUGAS_OK_BTN"),
                            onClick: this._onOkPressed,
                            className: CyClass('cy-state-select-approve-button')
                        }}
                    />
                </div>
            );
    }
}
